import type { ButtonProps } from '../../Button';

import { useTranslation } from 'react-i18next';

import { FloppyDiskIcon } from '../../../../images/shapes';

import Loader from '../../../Loader/Loader';
import Button from '../../Button';

interface SaveButtonProps extends ButtonProps {
  /**
   * Button label, default "Save changes"
   */
  label?: string;
  /**
   * Form id, if not provided form submission should be handled by onClick property
   */
  form?: string;
  /**
   * If save form is in progress
   */
  isSaving?: boolean;
  /**
   * If button is disabled
   */
  disabled?: boolean;
}

const SaveButton = ({
  label,
  isSaving = false,
  form,
  disabled = false,
  ...props
}: SaveButtonProps) => {
  const { t } = useTranslation();

  return (
    <Button
      buttonColor="blue"
      iconPosition="start"
      iconImage={
        isSaving ? (
          <Loader size="small" type="spinner-grid" />
        ) : (
          <FloppyDiskIcon className="w-3 min-w-3" />
        )
      }
      disabled={isSaving || disabled}
      {...(form ? { form, type: 'submit' } : {})}
      {...props}
    >
      {label || t('Global.SaveChanges')}
    </Button>
  );
};

export default SaveButton;
